<template>
	<div>
	<div v-show="detailShow" class="vx-row mb-6">
		<div class="vx-col w-full" v-show="edit">
			<edit ref="edit" @close="handleClose"></edit>
		</div>
	</div>
	<vx-card :title="title" v-show="!detailShow">
		<div class="vx-row mb-6">
			<div class="vx-col w-1/2">
				<label class="vs-input--label">Date</label>

				<date-range-picker
                  style="min-height: 40px"
                  class="w-full"
                  ref="picker"
                  opens="center"
                  :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd', separator: ' to ' }"
                  :singleDatePicker="false"
                  :timePicker="false"
                  :timePicker24Hour="false"
                  :showWeekNumbers="false"
                  :showDropdowns="false"
                  :autoApply="true"
                  :clear="true"
				  @update="dateRangeUpdate"
                  v-model="dateV2"
                  :linkedCalendars="true"
                >
                </date-range-picker>
				<!-- <vs-input class="w-full" v-model="date" type="date" v-validate="'required'" /> -->
			</div>
		</div>
		<select-territory @data="setTerritoryId"></select-territory>
		<div class="vx-row mb-6">
			<div class="vx-col w-1/2">
				<span>Collection Type</span>
				<multiselect v-model="collectionTypSelected" :options="collectionTypeOptions"
					placeholder="Type to search" track-by="name" label="name" :max-height="125" :allow-empty="true"
					:multiple="true">
					<span slot="noResult">Oops! No data found</span>
					<template slot="singleLabel" slot-scope="props">
						<span class="option__desc">
							<span class="option__title">{{ props.option.name }}</span>
						</span>
					</template>

					<template slot="option" slot-scope="props">
						<div class="option__desc">
							<span class="option__title">{{ props.option.name }}</span>
						</div>
					</template>
				</multiselect>
			</div>
		</div>

		<div class="vx-row mb-6">
			<div class="vx-col flex items-center justify-items-start gap-2">
				<vs-button @click="onClickSearch" size="small" color="primary" icon-pack="feather" icon="icon-search"
					title="Search">
					Search</vs-button>
				<vs-button @click="onClickRelease" size="small" color="success" icon-pack="feather"
					icon="icon-check" title="Release" v-if="showButtonRelease">Confirm To
					Released</vs-button>
			</div>
		</div>

		<div class="vx-row">
			<vs-tabs ref="tabs">
				<vs-tab label="Draft" @click="onClickTab('draft')">
					<div class="con-tab-ejemplo">
						<table-draft @data-print="onClickPrint" @change-tab="changeTab" ref="table_draft" :dateV2="dateV2" :date="this.date" @open-detail="handleShowDetail"
							:territoryID="this.territorryId" :collectionTypes="this.collectionTypSelected"></table-draft>
					</div>
				</vs-tab>
				<vs-tab label="Released" @click="onClickTab('released')">
					<div class="con-tab-ejemplo">
						<table-released @data-print="onClickPrint" @change-tab="changeTab" ref="table_released" :dateV2="dateV2" :date="this.date" @open-detail="handleShowDetail"
							:territoryID="this.territorryId" :collectionTypes="this.collectionTypSelected"></table-released>
					</div>
				</vs-tab>
			</vs-tabs>
		</div>
	</vx-card>
</div>
</template>

<script>
import moment from "moment";
import TableDraft from "./_tabs/table-draft.vue";
import TableReleased from "./_tabs/table-released.vue";
import SelectTerritory from "./select-territory.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Edit from "./edit.vue";

export default {
	components: {
		TableDraft,
		TableReleased,
		SelectTerritory,
		DateRangePicker,
		Edit,
	},
	data() {
		return {
			detailShow:false,
			edit:false,
			title: "Handover Document",
			date: moment().format("YYYY-MM-DD"),
			dateV2:{
				startDate: null,
				endDate: null,
			},
			showButtonRelease: true,
			// select territory
			selectedTerritory: null,
			optionTerritory: [],
			territorryId: null,
			territoryCode: null,
			collectionTypeOptions: [
				{ name: "On Route", value: 1 },
				{ name: "Off Route", value: 2 },
				{ name: "COD Driver", value: 3 },
				{ name: "COD Canvas", value: 4 },
				{ name: "COD LCO", value: 5 },
				{ name: "Payment Receive", value: 6 }, // MIX2-5186, perubahan dari "Cashier" menjadi "Payment Receive"
			],
			collectionTypSelected: null,
		};
	},
	mounted() {
	},
	filters: {
		formatDate(value) {
			if (value) {
				return moment(String(value)).format("YYYY-MM-DD");
			}
		},
	},
	methods: {
		dateRangeUpdate(){
			console.log("date range update =>",this.dateV2)
		},
		dateFormat(date) {
			let a = null;
			if (date != null) {
				a = moment(date).format("YYYY-MM-DD");
			}
			return a;
		},
		resetDate(){
			this.dateV2.startDate = null
			this.dateV2.endDate = null
		},
		onClickTab(type) {
			switch (type) {
				case "draft":
					this.showButtonRelease = true;
					break;
				case "released":
					this.showButtonRelease = false;
					break;
			}
		},
		setTerritoryId(id, code) {
			this.territorryId = id;
			this.territoryCode = code;
		},
    changeTab(type) {
      let types = ['draft', 'released']
      let index = types.indexOf(type);
      if(index < 0) {
        console.log("wkwkw salah")
        return false
      }
      this.$refs.tabs.activeChild(index);
      this.onClickTab(type);
    },
		onClickRelease() {
			this.$refs.table_draft.CheckValidSelectedRows();
			let collection_plan_ids = this.$refs.table_draft.selected_rows.map(
				(item) => item.id
			);
			if (collection_plan_ids.length == 0) {
				this.$vs.notify({
					title: "Warning",
					text: "Please select collection plan",
					color: "warning",
					position: "top-right",
				});
				return;
			}

			this.$vs.loading();

			this.$http
				.post("api/sfa/v1/collection-plan/multiple-handover/release", {
					ids: collection_plan_ids,
				})
				.then((response) => {
					if (response.code == 200) {
            this.changeTab('released');
						this.$vs.notify({
							title: "Success",
							text: "Collection plan has been handed over",
							color: "success",
							position: "top-right",
						});
					} else {
						this.$vs.notify({
							title: "Error",
							text: response.message,
							color: "danger",
							position: "top-right",
						});
					}
          this.$vs.loading.close();
				});
		},
		onClickSearch() {
      if (this.dateV2.startDate == null || this.dateV2.endDate == null) {
        this.$vs.notify({
					title: "Warning",
					text: "Please select date",
					color: "warning",
					position: "top-right",
				});
				return;
      }

      let search = ""
      let ref_tabs = [this.$refs.table_draft, this.$refs.table_released]

      let ref_table = null
      ref_tabs.forEach((tab, _) => {
        if(ref_table == null && tab) {
          ref_table = tab.table
          search = tab.table.search
        }
      })
			let params = {
				status: 1,
				start_date: this.dateFormat(this.dateV2.startDate),
				end_date: this.dateFormat(this.dateV2.endDate),
        search: search,
				territory_id: this.territorryId,
				length: 10,
			};

			if (this.collectionTypSelected != null) {
				params.collection_types = this.collectionTypSelected.map(
					(item) => item.value
				);
			}

			if (this.$refs.table_draft) {
        params.is_hand_over_draft = true;
				this.$refs.table_draft.getData(params);
				this.$forceUpdate();
			}

			if (this.$refs.table_released) {
        params.is_handed_over = true;
				this.$refs.table_released.getData(params);
				this.$forceUpdate();
			}

			this.$vs.notify({
				title: "Success",
				text: "Search data success",
				color: "success",
				position: "top-right",
			});
		},
		onSearchTerritory(query) {
			let company_id = this.$store.state.user.currentUser.company_id;
			this.$http
				.get(
					"api/sfa/v1/territory?company_id=" + company_id + "&search=" + query
				)
				.then((response) => {
					this.optionTerritory = response.data.records;
				});
		},
		onClickPrint(id, type, from) {
			this.$vs.loading();
			const currentDate = `${moment().format("YYYY-MM-DD")}`;
			var fileTitle = `COLLECTION_PLAN_REPORT_${currentDate}`;
			let ids;

			if (type == "excel" && (from == undefined || from == "")) {
				type = "is_export_excel=true";
				ids = "collection_plan_ids[]=" + id;
			}
			if (from == "rhp") {
				type = "is_export_excel=true";
				type += "&is_rhp=true";
				ids = "rhp_number=" + id;
			}
			moment(this.startDate).format("YYYY-MM-DD") +
				this.$http
					.get(`api/sfa/v1/collection-plan/multiple-export?${ids}&${type}`, {
						responseType: "arraybuffer",
						headers: {
							Accept: "application/octet-stream",
						},
					})
					.then((resp) => {
						this.$vs.loading.close();
						if (resp.status == "error") {
							this.$vs.notify({
								color: "danger",
								title: "Error",
								text: resp.message,
								position: "top-right",
								iconPack: "feather",
								icon: "icon-x-circle",
							});
						} else {
							var fileURL = window.URL.createObjectURL(new Blob([resp]));
							var fileLink = document.createElement("a");
							fileLink.href = fileURL;

							fileLink.setAttribute("download", fileTitle + ".xlsx");
							document.body.appendChild(fileLink);
							fileLink.click();
						}
					});
		},
		async fetchTerritory() {
			let company_id = this.$store.state.user.currentUser.company_id;
			const response = await this.$http.get(
				"api/sfa/v1/territory?company_id=" + company_id
			);

			this.optionTerritory = response.data.records;
		},
		customLabelTerritory({ name, code }) {
			return `${code} - ${name}`;
		},
		async handleShowDetail(id,action) {
			this.detailShow = true
			switch (action) {
				case 'edit':
					this.$refs.edit.ID = id
					await this.$refs.edit.getData()
					this.edit = true
					break;
        case 'view':
					this.$refs.edit.ID = id
					await this.$refs.edit.getData()
					this.$refs.edit.showButtonSave = false // ini harus setelah getData()
					this.edit = true
					break;
				}
		},
		handleClose(){
			this.edit = false
			this.show = false
			this.detailShow = false
			this.$refs.show.ID = 0
			this.$refs.edit.ID = 0
      this.onClickSearch()
		}
	},
};
</script>
